import { getRequestEvent, query } from '$app/server';
import type { Season } from '#lib/schema-extension.js';
import getHockeydataInstance from './hockeydata.js';

export const getDivisionInfo = query('unchecked', async (season: Season) => {
	return getHockeydataInstance(getRequestEvent().fetch).getDivisionInfo(season);
});

export const getGroupDivisionId = query('unchecked', ({ seasonId, leagueId }: Season) => {
	return getHockeydataInstance(getRequestEvent().fetch).getGroupDivisionId({ seasonId, leagueId });
});
export const getSeasonDivisionId = query('unchecked', ({ seasonId, leagueId }: Season) => {
	return getHockeydataInstance(getRequestEvent().fetch).getSeasonDivisionId({ seasonId, leagueId });
});
export const getPlayoffDivisionId = query('unchecked', ({ seasonId, leagueId }: Season) => {
	return getHockeydataInstance(getRequestEvent().fetch).getPlayoffDivisionId({
		seasonId,
		leagueId
	});
});
export const getGameReport = query('unchecked', (gameId: string) => {
	return getHockeydataInstance(getRequestEvent().fetch).getGameReport(gameId);
});
export const getPlayerInfo = query(
	'unchecked',
	({
		playerId,
		seasonId,
		divisionId
	}: {
		playerId: string;
		seasonId: string;
		divisionId: string;
	}) => {
		return getHockeydataInstance(getRequestEvent().fetch).getPlayerInfo(
			playerId,
			seasonId,
			divisionId
		);
	}
);
export const getSchedule = query('unchecked', ({ leagueId, seasonId }: Season) => {
	return getHockeydataInstance(getRequestEvent().fetch).getSchedule({ leagueId, seasonId });
});
export const getStandings = query('unchecked', ({ leagueId, seasonId }: Season) => {
	return getHockeydataInstance(getRequestEvent().fetch).getStandings({ leagueId, seasonId });
});
export const getNextMatch = query('unchecked', ({ seasonId, leagueId }: Season) => {
	return getHockeydataInstance(getRequestEvent().fetch).getNextMatch({
		seasonId,
		leagueId
	});
});
export const getTeamDetails = query(
	'unchecked',
	({ season, teamId }: { season: Season; teamId: string }) => {
		return getHockeydataInstance(getRequestEvent().fetch).getTeamDetails(season, teamId);
	}
);
export const getTeamImageUrl = query(
	'unchecked',
	({ season, teamId }: { season: Season; teamId: string }) => {
		return getHockeydataInstance(getRequestEvent().fetch).getTeamImageUrl(season, teamId);
	}
);
export const getKnockoutStage = query('unchecked', (divisionId: string) => {
	return getHockeydataInstance(getRequestEvent().fetch).getKnockoutStage(divisionId);
});
